<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">项目列表</span>
      <div class="action-container">
        <a-button v-if="canAddProject" type="primary" icon="plus" @click="onViewAgreement" class="page-title-btn">
          新建
        </a-button>
      </div>
    </div>
    <div class="content-container">
      <div class="list-container" style="margin-top: 20px;">
        <div class="table-btn-container">
          <a-space>
            <a-button v-if="canSetBatchNumber" type="default" size="small" @click="startConfigBatchNumber">
              设置批次号
            </a-button>
            <a-button type="default" size="small" @click="startDownloadZips">
              一键下载
            </a-button>
            <a-button type="danger" size="small" @click="startBatchDeleteProject">
              删除
            </a-button>
          </a-space>
          <span class="total-capacity-text">总装机容量：{{ totalCapacity }} MW</span>
        </div>
        <div class="search-container" style="margin: 0 0 10px 0;">
          <a-input size="small" placeholder="项目名称" v-model="searchParams.projectName" class="medium-search-input" />
          <a-input size="small" placeholder="所属公司" v-model="searchParams.companyName" class="medium-search-input" />
          <a-cascader size="small" placeholder="所在区域" :options="regionOptions" v-model="searchParams.regionIds" change-on-select style="width:240px;margin-right: 20px"  />
          <a-select
              size="small"
              v-model="searchParams.state"
              class="search-select" style="margin-right: 20px">
            <a-select-option value="">所有文档状态</a-select-option>
            <a-select-option value="待提交">待提交</a-select-option>
            <a-select-option value="待复核">待复核</a-select-option>
            <a-select-option value="复核驳回">复核驳回</a-select-option>
            <a-select-option value="待风险评估">待风险评估</a-select-option>
            <a-select-option value="风险评估驳回">风险评估驳回</a-select-option>
            <a-select-option value="风险评估完成">风险评估完成</a-select-option>
            <a-select-option value="确认收到">确认收到</a-select-option>
          </a-select>
          <a-select
              size="small"
              v-model="searchParams.engineeringNode"
              class="search-select" style="margin-right: 20px">
            <a-select-option value="">所有工程进度</a-select-option>
            <a-select-option value="INFO_COLLECTION">资料收集</a-select-option>
            <a-select-option value="INFO_REVIEW">资料审核</a-select-option>
            <a-select-option value="POWER_STATION_DESIGN">电站设计</a-select-option>
            <a-select-option value="POWER_STATION_CONSTRUCTION">电站施工</a-select-option>
            <a-select-option value="REQUEST_GRID_CONNECTION">并网申请</a-select-option>
            <a-select-option value="GRID_CONNECTION_ACCEPTANCE">并网验收</a-select-option>
            <a-select-option value="COMPLETION_ACCEPTANCE">竣工验收</a-select-option>
          </a-select>
          <a-select
              size="small"
              v-model="searchParams.paymentNode"
              class="search-select" style="margin-right: 20px">
            <a-select-option value="">所有付款进度</a-select-option>
            <a-select-option value="PREPAYING">申请预付款</a-select-option>
            <a-select-option value="PREPAID">预付款完成</a-select-option>
            <a-select-option value="GRID_CONNECTION_PAYMENT">并网请款</a-select-option>
            <a-select-option value="GRID_CONNECTION_PAID">并网款完成</a-select-option>
            <a-select-option value="REQUEST_COMPLETION_PAYMENT">竣工请款</a-select-option>
            <a-select-option value="COMPLETION_PAID">竣工款完成</a-select-option>
            <a-select-option value="ACCEPTANCE_TRANSFER">验收移交</a-select-option>
            <a-select-option value="REQUEST_WARRANTY_PAYMENT">质保金请款</a-select-option>
            <a-select-option value="WARRANTY_PAID">质保金付款完成</a-select-option>
          </a-select>
          <a-button
              size="small"
              @click="onSearch"
              class="search-btn"
          >搜索</a-button
          >
        </div>
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="pagination"
            :loading="loading"
            size="small"
            rowKey="projectId"
            @change="onTableChange"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"
        >
          <a-space slot="action" slot-scope="record">
            <a v-if="isEditable(record)" @click="onEdit(record)">继续填写</a>
            <a v-if="docReceivable(record)" @click="onReceive(record)">确认接收</a>
            <a @click="onView(record)">查看内容</a>
            <a v-if="record.canManageProgress" @click="manageProgress(record)">进度管理</a>
            <a v-if="record.metricZip!=null && record.metricZip!=''" :href="record.metricZip" target="_blank">资料下载</a>
          </a-space>
          <div slot="coloredProjectName" slot-scope="record">
            <div v-if="record.overallStatus === '复核驳回' || record.overallStatus === '风险评估驳回'"  class="warning-text">
              {{ record.projectName }}
            </div>
            <div v-else>
              {{ record.projectName }}
            </div>
            <div v-if="record.companyName!==null && record.companyName!==''" class="desc-text">{{ record.companyName }}</div>
          </div>
          <div slot="coloredProjectState" slot-scope="record">
            <span v-if="record.overallStatus === '复核驳回' || record.overallStatus === '风险评估驳回'"  class="warning-text">
              {{ record.overallStatus }}
            </span>
            <span v-else>
              {{ record.overallStatus }}
            </span>
          </div>
        </a-table>
      </div>
    </div>

    <a-modal
        :visible="modalVisible"
        title="设置批次号"
        okText="确定"
        cancelText="取消"
        @ok="onSetBatchNumber"
        @cancel="modalVisible = false">
      <div class="input-container">
        <span class="input-label">批次号</span><a-input v-model="batchNumber" placeholder="请输入批次号" class="val-input" />
      </div>
    </a-modal>

    <a-modal
        :visible="showAgreeModal"
        title="填报须知"
        okText="同意"
        cancelText="不同意"
        width="1000px"
        @ok="goEdit"
        @cancel="showAgreeModal = false">
      <div>
        <p class="p-agreement">尊敬的业务员：</p>
        <p class="p-agreement">您好！欢迎您登录本项目文档管理系统进行资料填报。</p>
        <p class="p-agreement">为确保所收集数据的真实性和有效性，保障项目的顺利推进，现向您明确以下填报要求：</p>
        <p class="p-agreement">1.真实性承诺</p>
        <p class="p-agreement">您在本平台填报的所有资料，包括但不限于项目厂房信息、项目进度、设备参数、相关合同文件等，必须确保真实、准确、完整。您所提交的每一项内容都应基于实际发生的事实，不得有任何虚假陈述、隐瞒或误导性信息。</p>
        <p class="p-agreement">2.责任与后果</p>
        <p class="p-agreement">您作为资料填报人，对所提交资料的真实性负有直接责任。若经核实发现存在弄虚作假行为，将视情节轻重采取相应措施，包括但不限于警告、暂停账号使用、追究法律责任等。同时，虚假信息可能导致项目决策失误，影响项目及各相关方的整体利益，进而对您个人的职业发展产生不利影响。</p>
        <p class="p-agreement">3.审核与监督</p>
        <p class="p-agreement">本平台将对您提交的资料进行严格审核，并可能随时要求您提供进一步的证明材料或补充说明。请您积极配合审核工作，确保审核流程顺利进行。此外，平台还将通过技术手段和不定期抽查等方式对填报数据进行监督，确保数据的真实性和可靠性。</p>
        <p class="p-agreement">4.数据更新与维护</p>
        <p class="p-agreement">项目在实施过程中可能会发生变化，请您及时更新相关资料，确保平台数据的时效性和准确性。如因资料更新不及时导致的问题，由您自行承担责任。</p>
        <p class="p-agreement">5.诚信与合作</p>
        <p class="p-agreement">请您始终秉持诚信原则，如实填报资料，与公司及项目团队保持良好合作。您的诚信行为将为新能源行业发展和个人职业声誉增添光彩，同时也为项目的成功实施提供有力保障。</p>
        <p class="p-agreement">感谢您的理解与配合！如有任何疑问，请随时联系我司：82707686。</p>
      </div>
    </a-modal>

  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import {listProjects, receiveDoc, setBatchNumber, batchDelete} from "@/services/DocService";
import {baseURL} from "@/services/HttpService";
import { regionOptions } from "@/geo/region";
import { isUserAdmin} from "@/services/UserService";
import {fetchDocListPermission} from "@/services/PermissionApi";
import {loadTaskCounts, refreshTaskCounts} from "@/services/DashboardService";

const tblColumns = [
  {
    title: "项目名称",
    scopedSlots: {customRender: "coloredProjectName"}
  },
  {
    title: "装机容量(MW)",
    dataIndex: "projectRecord",
    width: "8%"
  },
  {
    title: "所在区域",
    dataIndex: "regionFullName",
    width: "10%"
  },
  {
    title: "文档状态",
    scopedSlots: {customRender: "coloredProjectState"},
    width: "7%"
  },
  {
    title: "项目进度",
    dataIndex: "engineeringNodeName",
    width: "8%"
  },
  {
    title: "付款进度",
    dataIndex: "paymentNodeName",
    width: "8%"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    width: "12%"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {customRender: "action"},
    width: "20%"
  }
];
export default {
  components: { Breadcrumb },
  data() {
    return {
      tblColumns,
      tblData: [],
      regionOptions,
      searchParams: {
        projectName: "",
        companyName: "",
        batchNumber: "",
        state: "",
        engineeringNode:"",
        paymentNode:"",
        regionIds:[]
      },
      pagination: {
        size: "small",
        showQuickJumper: true
      },
      loading: false,
      viewUrl: baseURL + "/attachment?fileName=",
      selectedRowKeys: [],
      batchNumber: "",
      modalVisible: false,
      isAdmin: false,
      canSetBatchNumber: false,
      canAddProject: false,
      totalCapacity: 0,
      showAgreeModal: false
    };
  },
  computed: {
  },
  created() {
    isUserAdmin().then(resp => {
      if(resp.data.code === "SUCCESS") {
        this.isAdmin = resp.data.data;
      }
    });
    fetchDocListPermission().then(resp => {
      if(resp.data.code === "SUCCESS") {
        let permissions = resp.data.data;
        this.canSetBatchNumber = permissions.canSetBatchNumber;
        this.canAddProject = permissions.canAddProject;
        if(this.canSetBatchNumber===true) {
          this.addBatchNumberColumn();
        }
      }
    });
  },
  mounted() {
    this.fetchList();
    this.refreshTaskCounts();
  },
  methods: {
    refreshTaskCounts(){
      loadTaskCounts().then(response => {
        if (response.data.code === "FAILED") {
          console.log("服务端错误", response.data.errorMsg);
          this.$message.error("读取数据失败");
        } else {
          console.log('task counts:', response.data.data);
          this.$store.dispatch("updateTaskCounts", response.data.data);
        }
      });
    },
    addBatchNumberColumn(){
      const hasBatchNumberColumn = this.tblColumns.some(column => column.dataIndex === 'batchNumber');
      if (!hasBatchNumberColumn) {
        this.tblColumns.splice(2, 0, {
          title: "所属批次",
          dataIndex: "batchNumber",
          width: "8%"
        });
      }
    },
    startDownloadZips(){
      if(this.selectedRowKeys.length === 0) {
        this.$message.warn("请选择要下载资料的项目")
      } else {
        for(let i=0; i<this.selectedRowKeys.length; i++) {
          let projectId = this.selectedRowKeys[i];
          let project = this.findProject(projectId);
          let zipUrl = project.metricZip;
          if(zipUrl===undefined || zipUrl===null || zipUrl==='') {
            this.$message.warn("项目 "+project.projectName+" 的资料包还未生成");
          } else {
            window.open(zipUrl, '_blank');
          }
        }
      }
    },
    findProject(projectId){
      for(let i=0; i<this.tblData.length; i++) {
        if(this.tblData[i].projectId === projectId) {
          return this.tblData[i];
        }
      }
      return null;
    },
    startBatchDeleteProject(){
      if(this.selectedRowKeys.length === 0) {
        this.$message.warn("请选择要删除的项目")
      } else {
        let self = this;
        this.$confirm({
          title: "确定要删除吗?",
          okText: "确定",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            self.onBatchDelete();
          }
        });
      }
    },
    onBatchDelete(){
      batchDelete(this.selectedRowKeys).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.$message.success("删除成功");
          this.modalVisible = false;
          this.selectedRowKeys = []
          this.fetchList();
        } else {
          this.$message.error("设置失败:" + resp.data.errorMsg);
        }
      });
    },
    onSetBatchNumber(){
      if(this.batchNumber==="") {
        this.$message.warn("请输入批次号");
      } else {
        let params = {
          projectIdList: this.selectedRowKeys,
          batchNumber: this.batchNumber
        }
        setBatchNumber(params).then(resp => {
          if (resp.data.code === "SUCCESS") {
            this.$message.success("设置成功");
            this.modalVisible = false;
            this.selectedRowKeys = []
            this.fetchList();
          } else {
            this.$message.error("设置失败:" + resp.data.errorMsg);
          }
        });
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      console.log("selectedRowKeys changed: ", selectedRowKeys);
    },
    startConfigBatchNumber(){
      if(this.selectedRowKeys.length === 0) {
        this.$message.warn("请选择要操作的项目")
      } else {
        this.batchNumber = "";
        this.modalVisible = true;
      }
    },
    manageProgress(record){
      this.$router.push({path: `/adm/manage-progress/${record.projectId}`});
    },
    onTableChange(p) {
      this.fetchList(p.current, p.pageSize);
    },
    onSearch() {
      this.fetchList();
    },
    onReset() {
      this.searchParams.projectName = "";
      this.searchParams.companyName = "";
      this.searchParams.state = "";
      this.searchParams.batchNumber = "";
      this.searchParams.engineeringNode = "";
      this.searchParams.paymentNode = "";
      this.searchParams.regionIds = [];
      this.fetchList();
    },
    fetchList(pageNum = 1, pageSize = 10) {
      let params = {
        ...this.searchParams,
        pageNum,
        pageSize
      };

      listProjects(params)
          .then(response => {
            this.loading = false;
            if (response.data.code === "FAILED") {
              console.log("服务端错误", response.data.errorMsg);
              this.$message.error("读取数据失败");
            } else {
              this.setTblData(response);
            }
          });
    },
    setTblData(response) {
      let buzData = response.data.data;
      let rltList = buzData.records;
      if (rltList) {
        let totalCapacity = 0;
        rltList.forEach(item => {
          if (item.createTime) {
            item.createTime = tsFormat(item.createTime);
          }
          if(item.submitTime) {
            item.submitTime = tsFormat(item.submitTime);
          }
          if(item.assessTime) {
            item.assessTime = tsFormat(item.assessTime);
          }
          if(item.metricZip) {
            item.metricZip = this.viewUrl + item.metricZip;
          }
          if(item.engineeringNodeName===undefined || item.engineeringNodeName===null) {
            item.engineeringNodeName = '--';
          }
          if(item.paymentNodeName===undefined || item.paymentNodeName===null) {
            item.paymentNodeName = '--';
          }
          if(item.projectRecord && !isNaN(item.projectRecord)) {
            totalCapacity += parseFloat(item.projectRecord);
          }
        });
        let factor = Math.pow(10, 5); // 保留两位小数
        let capacity = Math.round(totalCapacity * factor) / factor;
        this.totalCapacity = capacity;
      }
      this.tblData = rltList;
      const pagination = { ...this.pagination };
      pagination.current = buzData.pageNum;
      pagination.total = buzData.total;
      pagination.pageSize = buzData.pageSize;
      pagination.showTotal = function (total, range) {
        return `当前显示 ${range[0]} - ${range[1]} 条, 共 ${total} 条`;
      };
      this.pagination = pagination;
    },
    isEditable(record) {
      return record.state==='未提交' || record.state==='已驳回'
          || record.rationaleState === '未提交' || record.rationaleState === '已驳回'
          || record.riskReviewState === '已驳回'
          || record.rationaleRiskState === '已驳回';
    },
    // 查看填报协议
    onViewAgreement(){
      this.showAgreeModal = true;
    },
    goEdit() {
      this.$router.push({path: `/adm/edit-doc/0/audit`});
    },
    onView(record){
      this.$router.push({path: `/adm/view-doc/${record.projectId}`});
    },
    docReceivable(record) {
      return record.riskReviewState==='通过'
          && record.rationaleRiskState === '通过'
          && record.internalRiskState==='通过'
          && record.engineerReceived !== "确认收到";
    },
    onEdit(record) {
      let mode = 'audit';
      if(record.state==='通过' && record.rationaleState==='通过' && record.internalState === '通过') {
        mode = 'risk-approve';
      }
      this.$router.push({path: `/adm/edit-doc/${record.projectId}/${mode}`});
    },
    canStartSectionTwo(record){
      return record.state==='通过'
          && (record.rationaleState==='未提交' || record.rationaleState==='已驳回');
    },
    onEditSectionTwo(record) {
      this.$router.push({path: `/adm/section-two/${record.projectId}/audit`});
    },
    canStartSectionThree(record){
      return record.rationaleState==='通过'
          && (record.internalState==='未提交' || record.internalState==='已驳回');
    },
    onEditSectionThree(record) {
      this.$router.push({path: `/adm/section-three/${record.projectId}/audit`});
    },
    onRiskApproveSectionOne(record) {
      this.$router.push({path: `/adm/add-doc/${record.projectId}/risk-approve`});
    },
    onRiskApproveSectionTwo(record) {
      this.$router.push({path: `/adm/section-two/${record.projectId}/risk-approve`});
    },
    onRiskApproveSectionThree(record) {
      this.$router.push({path: `/adm/section-three/${record.projectId}/risk-approve`});
    },
    onAudit(record) {
      this.$router.push({path: `/adm/audit-doc/${record.projectId}`});
    },
    onReceive(record) {
      let that = this;
      this.$confirm({
        title: "工程人员确认收到文档?",
        okText: "是",
        okType: "warning",
        cancelText: "否",
        onOk() {
          receiveDoc(record.projectId).then(resp => {
            if (resp.data.code === "SUCCESS") {
              that.$message.success("操作成功");
              that.fetchList();
            } else {
              that.$message.error("操作成功:" + resp.data.errorMsg);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.table-btn-container {
  padding: 10px 0;
}
.input-container{
  padding-top: 4px;
  padding-bottom: 4px;
}
.input-label {
  display: inline-block;
  width: 100px;
  margin-right: 10px;
}
.val-input {
  width: 200px;
}
.desc-text {
  font-size: 12px;
  color: #999;
}
.total-capacity-text {
  font-size: 12px;
  color: #999;
  margin-left: 50px;
}
.p-agreement {
  text-indent: 2em;
}
</style>
